import React, { useRef } from 'react';

import { useClassnames } from '@lumapps/classnames';
import { DOCUMENTATION_LINKS, ReferToDocumentation } from '@lumapps/lumx-texts/components/ReferToDocumentation';
import { Message, Tooltip, Text } from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';
import { upperSnakeCase } from '@lumapps/utils/string/upperSnakeCase';

import { getWidgetDeprecationWarningMessage } from '../../keys';

import './index.scss';

const CLASSNAME = 'widget-deprecation-warning';

export interface WidgetDeprecationWarningProps {
    isLarge?: boolean;
    widgetType: string;
}

export const WidgetDeprecationWarning = ({ isLarge = false, widgetType = '' }: WidgetDeprecationWarningProps) => {
    const anchorRefTooltip = useRef(null);
    const { translateKey } = useTranslate();
    const widgetTypeUpperSnakeCase = upperSnakeCase(widgetType);
    const { block } = useClassnames(CLASSNAME);

    const widgetDeprecationWarningMessage = getWidgetDeprecationWarningMessage(widgetTypeUpperSnakeCase);

    return (
        <Tooltip label={!isLarge && translateKey(widgetDeprecationWarningMessage)}>
            <Message
                className={block({
                    'is-large': isLarge,
                })}
                ref={anchorRefTooltip}
                hasBackground
                kind="warning"
            >
                <Text as="p">
                    {isLarge ? translateKey(widgetDeprecationWarningMessage) : translateKey(GLOBAL.DEPRECATED)}
                    {isLarge && (
                        <ReferToDocumentation
                            link={DOCUMENTATION_LINKS.widget.deprecated}
                            as="p"
                            typography="caption"
                        />
                    )}
                </Text>
            </Message>
        </Tooltip>
    );
};
